import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const VEILS = {
  medium: "from-[#050505]/80 via-transparent to-[#050505]/80",
  strong: "from-[#050505] via-[#050505]/75 to-[#050505]",
};

export const SectionBackdrop = ({ images, opacity = 0.24, veil = "medium" }) => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % images.length), 7000);
    return () => clearInterval(t);
  }, [images.length]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <AnimatePresence mode="sync">
        <motion.img
          key={idx}
          src={images[idx]}
          alt=""
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity, scale: 1.07 }}
          exit={{ opacity: 0 }}
          transition={{
            opacity: { duration: 2.4, ease: "easeInOut" },
            scale: { duration: 10, ease: "linear" },
          }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>
      <div className={`absolute inset-0 bg-gradient-to-b ${VEILS[veil]}`} />
    </div>
  );
};
